import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Component from './component'
import { login } from '../../ducks/auth'
import { push } from 'react-router-redux'

function mapStateToProps (state, ownProps) { // eslint-disable-line no-unused-vars
  let path

  if (state.router && typeof state.router === 'object' && state.router.hasOwnProperty('location') && state.router.location && typeof state.router.location === 'object') {
    path = state.router.location.pathname
  }

  if (typeof path !== 'string') {
    path = '/'
  }

  return {
    ...ownProps,
    loggedIn: state.auth.loggedIn,
    loggingIn: state.auth.loggingIn,
    user: state.auth.user,
    path
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({ login, navigate: push }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)



// WEBPACK FOOTER //
// ./ui/app/index.js